import { ConfigRelatedDataSource } from "../types";

export const getChartFilterName = (relatedDataSources: ConfigRelatedDataSource[]): string => {
  const relatedAttributes = relatedDataSources || [];
  const axes = relatedAttributes.filter(({ chartAxis }) => chartAxis === "y");

  return axes?.[0]?.filterName;
};
